<script lang="ts">
	import type { Notification } from './notifications';
	import Snackbar from '$lib/components/atoms/snackbar/Snackbar.svelte';
	import { onMount } from 'svelte';

	interface Props {
		notification: Notification;
		onClose?: () => void;
	}

	const { notification, onClose = () => {} }: Props = $props();
	let timer: ReturnType<typeof setTimeout> | null = null;
	let hover = false;
	let closeOnLeave = false;

	function mouseenter() {
		hover = true;
	}

	function mouseleave() {
		hover = false;
		if (closeOnLeave) {
			close();
		}
	}

	function stopTimer() {
		if (timer) {
			clearTimeout(timer);
			timer = null;
		}
	}

	function close() {
		stopTimer();
		onClose();
	}

	onMount(() => {
		const timeout = notification.timeout;
		if (timeout) {
			timer = setTimeout(() => {
				if (hover) {
					closeOnLeave = true;
				} else {
					close();
				}
			}, timeout);
		}
		return () => {
			stopTimer();
		};
	});
</script>

<div onmouseenter={mouseenter} onmouseleave={mouseleave} role="alert">
	<Snackbar
		text={notification.message}
		showCloseButton={notification.closable}
		closeButton={notification.closeButton}
		onClose={() => {
			notification.onCloseCallback?.();
			close();
		}}
	/>
</div>
